import { useLayoutEffect, useState } from 'react';

/**
 * Mounts the consumer with `deferredOpen=false`, then transitions to `isOpen` on
 * the next layout effect. Guarantees the Mantine Drawer slide-in animation plays
 * because the DOM was previously painted with `opened=false`.
 *
 * Important: callers must NOT remount when opening — toggle `isOpen` on an
 * already-mounted instance so the previous paint acts as the CSS transition
 * start state.
 */
export const useDeferredOpen = (isOpen: boolean): boolean => {
  const [deferredOpen, setDeferredOpen] = useState(false);
  useLayoutEffect(() => {
    setDeferredOpen(isOpen);
  }, [isOpen]);
  return deferredOpen;
};
